// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RedoOutlinedSvg from "@fishx/icons-svg/es/asn/RedoOutlined";
import FishxIcon from '../components/FishxIcon';

var RedoOutlined = function RedoOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: RedoOutlinedSvg
  }));
};

RedoOutlined.displayName = 'RedoOutlined';
export default React.forwardRef(RedoOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/RedoOutlined.js
// module id = 3989
// module chunks = 0